import { Theme } from '@mui/material';
import { createTheme } from '@mui/material/styles';

const theme = {
  custom: {
    palette: {
      primary: {
        default: '#6c63ff',
        background: '#f8f9fb',
        // light: '#ded9fa',
        hover: '#8B73FF',
        // dark: '#3A19DC',
        white: '#fff',
        black: '#000',
        basegray: '#96a3b7',
        lightgray: '#d3d3d3',
      },

      shadow: {
        default: '0 10px 10px -5px rgba(0,0,0,0.3)',
        // hover: '0px 12px 20px rgba(139,115,255,0.2)',
        // dark: '0px 4px 10px rgba(58,25,220,0.2)',
      },
    },
    // default: '#fefefe',
    // background: '#f8f9fb',
    // black: '#000',
  },

  typography: {
    fontFamily: 'Montserrat',
    h1: {
      fontSize: 36,
      fontWeight: 700,
      lineHeight: '42px',
      letterSpacing: 0,
      fontStyle: 'normal',
    },

    h2: {},

    h3: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '31.2px',
      fontStyle: 'normal',
    },

    h4: {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '20.8px',
      fontStyle: 'normal',
    },

    h5: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: '20.8px',
      fontStyle: 'normal',
    },

    body1: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '18.9px',
      fontStyle: 'normal',
    },

    subtitle1: {
      color: '#64748B',
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '19px',
      letterSpacing: '0em',
    },

    small: {
      fontSize: 12,
      color: 'red',
    },
  },

  components: {
    MuiSvgIcon: {
      styleOverrides: {
        colorPrimary: {
          color: '#96a3b7',
        },
      },
    },
  },

  breakpoints: {
    values: {
      mobile: 320,
      tablet: 768,
      laptop: 1024,
      desktop: 1280,
    },
  },
} as any;

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    mobile: true; // adds the `mobile` breakpoint
    mobileMedium: true;
    mobileLarge: true;
    tablet: true;
    laptop: true;
    desktop: true;
  }
}

declare module '@mui/material/styles' {
  interface DefaultTheme extends Theme {}
}

type CustomTheme = {
  // [Key in keyof typeof theme]: typeof theme[Key]
  [Key in any]: any;
};

declare module '@mui/material/styles/createTheme' {
  interface Theme extends CustomTheme {}

  interface DeprecatedThemeOptions extends CustomTheme {}
}

declare module '@mui/material/styles' {
  interface TypographyVariants {
    small: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    small?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    small: true;
  }
}

export default createTheme(theme);
